import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { toast } from 'sonner';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const STATES = 'AL AK AZ AR CA CO CT DE DC FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY'.split(' ');

const FIELDS = [
  { key: 'name', label: 'Agency name' },
  { key: 'provider_number', label: 'Provider No. (Medicare / state)' },
  { key: 'phone', label: 'Telephone' },
  { key: 'fax', label: 'Fax' },
];

export default function AgencyProfileDialog({ open, onOpenChange }) {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!open) return;
    setLoading(true);
    api.get('/agency-profile').then(r => setForm(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [open]);
  const save = async () => {
    setSaving(true);
    try {
      await api.put('/agency-profile', form);
      toast.success('Agency details saved — forms will auto-fill them');
      onOpenChange(false);
    } catch (e) { toast.error(e?.response?.data?.detail || 'Could not save'); }
    finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="agency-profile-dialog">
        <DialogHeader><DialogTitle>Agency details for forms</DialogTitle></DialogHeader>
        <p className="text-xs text-[#64748B]">Used to fill provider boxes such as CMS-485 items 5 and 7.</p>
        <fieldset className={`space-y-3 transition-opacity ${loading ? 'opacity-50' : ''}`} disabled={loading} data-testid="agency-form-fields">
          {FIELDS.map(f => (
            <div key={f.key}>
              <Label className="text-xs">{f.label}</Label>
              <Input value={form[f.key] || ''} onChange={e => setForm({ ...form, [f.key]: e.target.value })} data-testid={`agency-${f.key}-input`} />
            </div>
          ))}
          <div>
            <Label className="text-xs">State — filters the Form Library</Label>
            <Select value={form.state || '__none__'} onValueChange={v => setForm({ ...form, state: v === '__none__' ? '' : v })}>
              <SelectTrigger data-testid="agency-state-select"><SelectValue /></SelectTrigger>
              <SelectContent className="max-h-72">
                <SelectItem value="__none__">Not set</SelectItem>
                {STATES.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs">Address</Label>
            <Textarea rows={2} value={form.address || ''} onChange={e => setForm({ ...form, address: e.target.value })} data-testid="agency-address-input" />
          </div>
        </fieldset>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button className="careiq-btn-primary" onClick={save} disabled={saving || loading} data-testid="agency-save-btn">Save</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
